/** Служебные запросы: версия сборки. */

import { useQuery } from '@tanstack/react-query'

import { apiFetch } from './client'

export interface VersionInfo {
  version: string
  commit: string
}

export function fetchVersion(): Promise<VersionInfo> {
  return apiFetch<VersionInfo>('/version')
}

export function useVersion() {
  return useQuery({
    queryKey: ['version'],
    queryFn: fetchVersion,
    staleTime: 5 * 60 * 1000,
    retry: false,
  })
}
